export default "__VITE_ASSET__Bsy5B3xh__"